module.exports = __webpack_public_path__ + "img/Giorgia.5407bcd.png";